// Todo: Add delete account to remove all of users data from our database
import { Mutation, Query } from '@apollo/client/react/components';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { CHANGE_SETTINGS, GET_SETTINGS } from '../../helpers/graphql/settings';
import UserContext from '../General/UserContext';
import DashboardCard from './DashboardCard';
import NotificationsToggle from './Settings/NotificationsToggle';
import Typography from '@mui/material/Typography';
import LinkAcounts from 'components/Dashboard/Settings/LinkAccounts';
import Divider from '@mui/material/Divider';
import DeleteAccountBtn from './DeleteAccountBtn';

const Settings = props => {
  const { theme, setDarkMode, setLightMode } = useContext(UserContext);

  const useDarkMode = theme === 'dark';
  const [loaded, setLoaded] = useState(false);
  const [saved, setSaved] = useState(true);
  const [notificationPermission, setNotificationPermission] = useState(false);
  const [trackFollows, setTrackFollows] = useState(false);
  const [trackMentions, setTrackMentions] = useState(false);
  const [trackReplies, setTrackReplies] = useState(false);
  const [trackCuration, setTrackCuration] = useState(false);
  const [trackUpdates, setTrackUpdates] = useState(false);
  const [useAdvancedEditorOptions, setUseAdvancedEditorOptions] = useState(
    false,
  );
  const [claimRewards, setClaimRewards] = useState(false);

  // const [roles, setRoles] = useState(undefined);

  useEffect(() => {
    // setRoles(getRoles());

    // https://developers.google.com/web/updates/2015/03/push-notifications-on-the-open-web

    // Are Notifications supported in the service worker?
    if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
      return;
    }

    // Check the current Notification permission.
    // If its denied, it's a permanent block until the
    // user changes the permission
    if (Notification.permission === 'denied') {
      return;
    }

    // Check if push messaging is supported
    if (!('PushManager' in window)) {
      return;
    }
    setNotificationPermission(Notification.permission === 'granted');
  }, []);

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = props;
      enqueueSnackbar(notification.message, { variant });
    }
  };

  const handleCheckboxChange = name => event => {
    if (name === 'useDarkMode') {
      if (useDarkMode) setLightMode();
      else setDarkMode();
    } else if (name === 'useAdvancedEditorOptions') {
      setUseAdvancedEditorOptions(event.target.checked);
    } else if (name === 'trackFollows') {
      setTrackFollows(event.target.checked);
    } else if (name === 'trackMentions') {
      setTrackMentions(event.target.checked);
    } else if (name === 'trackReplies') {
      setTrackReplies(event.target.checked);
    } else if (name === 'trackCuration') {
      setTrackCuration(event.target.checked);
    } else if (name === 'trackUpdates') {
      setTrackUpdates(event.target.checked);
    } else if (name === 'claimRewards') {
      setClaimRewards(event.target.checked);
    } else if (name === 'notificationPermission') {
      if (!notificationPermission)
        Notification.requestPermission(status => {
          setNotificationPermission(status === 'granted');
        });
      setNotificationPermission(false);
    }
  };

  return (
    <>
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '800px' }}>
          <Query fetchPolicy="network-only" query={GET_SETTINGS}>
            {({ data }) => {
              if (loaded === false && data && data.preferences) {
                setLoaded(true);
                setTrackFollows(data.preferences.trackFollows);
                setTrackMentions(data.preferences.trackMentions);
                setTrackReplies(data.preferences.trackReplies);
                setTrackCuration(data.preferences.trackCuration);
                setTrackUpdates(data.preferences.trackUpdates);
                setUseAdvancedEditorOptions(
                  data.preferences.useAdvancedEditorOptions !== false,
                );
                setClaimRewards(data.preferences.claimRewards);
                return <></>;
              }
              return (
                <>
                  <DashboardCard
                    title="Settings"
                    titleSize="h5"
                    content={
                      <Mutation
                        mutation={CHANGE_SETTINGS}
                        variables={{
                          trackFollows,
                          trackMentions,
                          trackReplies,
                          trackCuration,
                          trackUpdates,
                          useAdvancedEditorOptions,
                          claimRewards,
                        }}
                      >
                        {
                          // eslint-disable-next-line no-shadow
                          (changeSettings, data) => {
                            if (data && data.loading && saved) {
                              setSaved(false);
                            }
                            if (data && data.error) {
                              newNotification({
                                success: false,
                                message: 'Network Error. Are you online?',
                              });
                            }
                            if (data && data.data && !saved) {
                              newNotification({
                                success: data.data.updatePreferences.success,
                                message: data.data.updatePreferences.message,
                              });
                              setSaved(true);
                            }
                            return (
                              <>
                                <Typography
                                  variant="h6"
                                  component="h2"
                                  gutterBottom
                                >
                                  General
                                </Typography>
                                <FormControl variant="standard" fullWidth>
                                  <FormGroup>
                                    <FormControlLabel
                                      labelPlacement="end"
                                      control={
                                        <Switch
                                          checked={useAdvancedEditorOptions}
                                          onChange={handleCheckboxChange(
                                            'useAdvancedEditorOptions',
                                          )}
                                          onInput={changeSettings}
                                          value="useAdvancedEditorOptions"
                                          color="primary"
                                        />
                                      }
                                      label="Advanced editor options"
                                    />
                                    <FormControlLabel
                                      labelPlacement="end"
                                      control={
                                        <Switch
                                          checked={useDarkMode}
                                          onChange={handleCheckboxChange(
                                            'useDarkMode',
                                          )}
                                          // onInput={changeSettings}
                                          // For now, dark mode is saved on the device only
                                          value="useDarkMode"
                                          color="primary"
                                        />
                                      }
                                      label="Use night mode"
                                    />
                                    <Divider className="tw-pt-6" />

                                    <Typography
                                      variant="h6"
                                      component="h2"
                                      className="pt-4"
                                      gutterBottom
                                    >
                                      Notifications
                                    </Typography>
                                    <NotificationsToggle
                                      setNotificationPermission={
                                        setNotificationPermission
                                      }
                                    />
                                    {notificationPermission && (
                                      <>
                                        <FormControlLabel
                                          labelPlacement="end"
                                          control={
                                            <Switch
                                              checked={trackFollows}
                                              onChange={handleCheckboxChange(
                                                'trackFollows',
                                              )}
                                              color="primary"
                                              onInput={changeSettings}
                                            />
                                          }
                                          label="Notify for new followers"
                                        />
                                        <FormControlLabel
                                          labelPlacement="end"
                                          control={
                                            <Switch
                                              checked={trackMentions}
                                              onChange={handleCheckboxChange(
                                                'trackMentions',
                                              )}
                                              color="primary"
                                              onInput={changeSettings}
                                            />
                                          }
                                          label="Notify when mentioned"
                                        />
                                        <FormControlLabel
                                          labelPlacement="end"
                                          control={
                                            <Switch
                                              checked={trackReplies}
                                              onChange={handleCheckboxChange(
                                                'trackReplies',
                                              )}
                                              color="primary"
                                              onInput={changeSettings}
                                            />
                                          }
                                          label="Notify when someone replies to you"
                                        />
                                        <FormControlLabel
                                          labelPlacement="end"
                                          control={
                                            <Switch
                                              checked={trackCuration}
                                              onChange={handleCheckboxChange(
                                                'trackCuration',
                                              )}
                                              color="primary"
                                              onInput={changeSettings}
                                            />
                                          }
                                          label="Notify when your post is featured"
                                        />
                                        <FormControlLabel
                                          labelPlacement="end"
                                          control={
                                            <Switch
                                              checked={trackUpdates}
                                              onChange={handleCheckboxChange(
                                                'trackUpdates',
                                              )}
                                              color="primary"
                                              onInput={changeSettings}
                                            />
                                          }
                                          label="Receive notifications about TravelFeed updates"
                                        />
                                      </>
                                    )}
                                  </FormGroup>
                                </FormControl>
                                <Divider className="tw-pt-6" />
                                <Typography
                                  variant="h6"
                                  component="h2"
                                  className="pt-4"
                                  gutterBottom
                                >
                                  Hive
                                </Typography>
                                <LinkAcounts
                                  hive
                                  showIfLinked={
                                    <FormControlLabel
                                      labelPlacement="end"
                                      control={
                                        <Switch
                                          checked={claimRewards}
                                          onChange={handleCheckboxChange(
                                            'claimRewards',
                                          )}
                                          onInput={changeSettings}
                                          value="claimRewards"
                                          color="primary"
                                        />
                                      }
                                      label="Automatically claim rewards"
                                    />
                                  }
                                />

                                <Divider className="tw-pt-6" />

                                {/* <Typography
                                  variant="h6"
                                  component="h2"
                                  className="pt-4"
                                  gutterBottom
                                >
                                  Steem
                                </Typography>
                                <LinkAcounts steem />
                                <Divider className="tw-pt-6" /> */}
                                <DeleteAccountBtn />
                              </>
                            );
                          }
                        }
                      </Mutation>
                    }
                  />
                  {
                    // TODO: Review and re-enable
                    // {roles && roles.indexOf('easylogin') === -1 && <LinkEasyLogin />}
                  }
                </>
              );
            }}
          </Query>
        </div>
      </div>
    </>
  );
};

Settings.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};
export default withSnackbar(Settings);
